import {
  CurrencyValueProps,
  Notation
} from '@blockanalitica/ui/package/types/src/components/molecules/CurrencyValue/CurrencyValue';
import { ComponentFactory } from '@blockanalitica/ui/package/types/src/theme/types';

export function currencyValue(): ComponentFactory<Partial<CurrencyValueProps>> {
  return {
    componentName: 'currencyValue',
    props: {
      options: {
        iconSize: '2',
        trendIconSize: '0',
        currencySize: null,
        trend: false,
        trendIcon: true,
        notation: 'compact' as Notation,
        trailingCurrencySymbol: false,
        tooltip: true,
        iconOpacity: 1
      }
    }
  };
}
